import C from "../constants";

export default function data(state = {}, payload) {
  let { type, key, data } = payload;
  switch (type) {
    case C.UPDATE_DATA:
      return { ...state, [key]: data };
    case C.SET_ACTIVE_ASSET_COLLECTION:
      return { ...state, activeAssetCollection: data };
    case C.GET_UPDATE_VIEW_REPORT_DETAILS:
      return { ...state, updateViewReport: { status: "loading", message: "", data: [] } };
    case C.VIEW_REPORT_DETAILS_RECEIVED:
      return { ...state, updateViewReport: { status: "success", message: "", data } };
    case C.GET_ALL_CATEGORY_LIST:
      return { ...state, categoryList: { status: "loading", message: "", data: [] } };
    case C.CATEGORY_LIST_RECEIVED:
      return { ...state, categoryList: { status: "success", message: "", data } };
    default:
      return state;
  }
}
